<!-- src/components/DownloadHint.vue -->
<template>
  <div>
    <div v-if="visible" class="download-hint">
      请下载我们的APP，点击 <a :href="downloadLink" target="_blank">这里</a> 获取下载链接
      <button @click="hideHint">今天不再提示</button>
    </div>
  </div>

</template>

<script>
import api from "../utils/api";

export default {
  computed: {
    visible() {
      return this.$store.state.hintVisible;
    },
  },
  data() {
    return {
      downloadLink: 'https://www.eforall.cn/profile/upload/ttsDownload/index.html#/', // 替换为实际的APP下载链接
    };
  },
  mounted() {

  },
  methods: {
    hideHint() {
      // 设置过期时间为当天的凌晨12点
      const now = new Date();
      const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      const expirationTime = tomorrow.getTime(); // 明天的0点的时间戳

      // 将过期时间保存到 localStorage
      localStorage.setItem('downloadHintExpiration', expirationTime);

      // 更新 Vuex 状态
      this.$store.commit('setHintVisible', false);
    },
  },
  created() {
    // 初始化提示状态
    this.$store.dispatch('initializeHint');
  },
};
</script>

<style scoped>
.download-hint {
  background-color: #ffefc4;
  color: #000;
  padding: 10px;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/DownloadHint.vue